var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3RadiantCeiling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H11V15h54v50zM17.61 48.25l6.49-7.83-6.49-7.82 6.3-7.6h5.24l-6.3 7.6 6.49 7.83-6.49 7.83 5.6 6.74h-5.24l-5.6-6.75zm9.7-15.66l6.3-7.6h5.24l-6.3 7.6L39 40.43l-6.49 7.83L38.15 55h-5.24l-5.59-6.75 6.49-7.83-6.5-7.83zm9.7 0l6.3-7.6h5.24l-6.3 7.6 6.49 7.83-6.49 7.83 5.6 6.75h-5.24L37 48.25l6.49-7.83-6.48-7.83zm9.7 0L53 25h5.24L52 32.6l6.49 7.83L52 48.25 57.55 55h-5.24l-5.59-6.75 6.49-7.83-6.5-7.83z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Radiant_ceiling.ac722e16.svg";
export { SvgB3RadiantCeiling as ReactComponent };